import { useEffect, useState } from 'react';
import { useMobileDetection } from './useMobileDetection';

interface VisualViewportDimensions {
  height: number;
  width: number;
  offsetTop: number;
  offsetLeft: number;
  scale: number;
}

export function useVisualViewport() {
  const [viewport, setViewport] = useState<VisualViewportDimensions>({
    height: window.innerHeight,
    width: window.innerWidth,
    offsetTop: 0,
    offsetLeft: 0,
    scale: 1,
  });

  const isMobile = useMobileDetection();

  useEffect(() => {
    if (!isMobile || !window.visualViewport) {
      return;
    }

    const updateViewport = () => {
      const vv = window.visualViewport!;
      setViewport({
        height: vv.height,
        width: vv.width,
        offsetTop: vv.offsetTop,
        offsetLeft: vv.offsetLeft,
        scale: vv.scale,
      });
    };

    const updateDocumentHeight = () => {
      const vh = window.visualViewport!.height;
      document.documentElement.style.height = `${vh}px`;
      document.body.style.height = `${vh}px`;
    };

    updateViewport();
    updateDocumentHeight();

    window.visualViewport.addEventListener('resize', updateViewport);
    window.visualViewport.addEventListener('scroll', updateViewport);
    window.visualViewport.addEventListener('resize', updateDocumentHeight);

    return () => {
      window.visualViewport?.removeEventListener('resize', updateViewport);
      window.visualViewport?.removeEventListener('scroll', updateViewport);
      window.visualViewport?.removeEventListener(
        'resize',
        updateDocumentHeight
      );
      document.documentElement.style.height = '';
      document.body.style.height = '';
    };
  }, [isMobile]);

  return {
    height: viewport.height,
    width: viewport.width,
    offsetTop: viewport.offsetTop,
    offsetLeft: viewport.offsetLeft,
    scale: viewport.scale,
    isKeyboardVisible:
      isMobile &&
      window.visualViewport &&
      viewport.height < window.innerHeight * 0.8,
  };
}
